export const DETAIL_GET = "DETAIL_GET";
export const DETAIL_RESET = "DETAIL_RESET";
